import { meiliClient } from '@common/meili';
import { ARTICLES_PER_PAGE, GUIDES_PER_PAGE } from 'sly/resourceCenter/helpers';
import SearchResultPage from 'sly/resourceCenter/pages/SearchResultPage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default SearchResultPage;

export async function getServerSideProps({ query }) {
  const { api, store } = createApiClient(apiEndpoints);

  const { searchBy } = query;
  const pageNumber = Number(query['page-number']) || 1;

  let res;
  try {
    res = await meiliClient.multiSearch({
      queries: [
        {
          indexUid: 'senior-living-type',
          q: searchBy,
          page: pageNumber,
          hitsPerPage: GUIDES_PER_PAGE,
        },
        {
          indexUid: 'article',
          q: searchBy,
          page: pageNumber,
          hitsPerPage: ARTICLES_PER_PAGE,
        },
      ],
    });
  } catch (e) {
    console.log(e);
  }

  try {
    await Promise.all(
      [
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      redirect: {
        destination: '/resource-center',
        permanent: false,
      },
    };
  }

  const hits = [
    ...(res?.results?.[0]?.hits || []),
    ...(res?.results?.[1]?.hits || []),
  ];
  const totalHits = res?.results?.[0]?.totalHits + res?.results?.[1]?.totalHits;

  const totalPages = Math.max(
    res?.results[0]?.totalPages,
    res?.results[1]?.totalPages
  );

  return {
    props: {
      initialApiState: store.getState(),
      query,
      hits,
      totalHits,
      totalPages,
      guidePages: res.results[0].totalPages,
      guideHits: res.results[0].totalHits,
    },
  };
}
